import React, { useState } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import AlertLimitUpgradeModal from "components/Alerts/AlertLimitUpgradeModal";
import PlanProgressBar from "./PlanProgressBar";
import styles from "./style.module.scss";

const PlanOrgQuota = ({
  limits,
  canPurchase,
  loading,
  isEnterprise = false,
  onContactSales,
}) => {
  const { t } = useTranslation();
  const [showUpgrade, setShowUpgrade] = useState(false);

  if (loading && !limits) {
    return (
      <PlanProgressBar
        label={t("settings.plan_kpis_label", "KPI'lar (organizasyon)")}
        used={0}
        max={25}
        sublabel={t("settings.plan_loading")}
      />
    );
  }

  if (!limits) {
    return null;
  }

  const {
    used: alertsUsed = 0,
    max_allowed: alertsMax = 10,
    addon_active: addonActive,
    remaining: alertsRemaining = 0,
    kpi_used: kpiUsed = 0,
    kpi_max_allowed: kpiMax = 25,
    kpi_remaining: kpiRemaining = 0,
    paid_pack_size: packSize = 10,
  } = limits;

  return (
    <>
      <PlanProgressBar
        label={t("settings.plan_kpis_label", "KPI'lar (organizasyon)")}
        sublabel={
          addonActive
            ? t(
                "settings.plan_kpis_addon_active",
                "Temel 25 + aylık add-on (+{{pack}} KPI)",
                { pack: packSize },
              )
            : t(
                "settings.plan_kpis_free_tier",
                "İlk 25 KPI ücretsiz (tüm ekipler)",
              )
        }
        used={kpiUsed}
        max={kpiMax}
        footer={
          <span className={styles.quotaProgressCaption}>
            {t("settings.plan_kpis_remaining_hint", "{{count}} hak kaldı", {
              count: kpiRemaining,
            })}
          </span>
        }
      />

      <PlanProgressBar
        label={t("settings.plan_alerts_label", "Alarmlar")}
        sublabel={
          addonActive
            ? t(
                "settings.plan_alerts_addon_active",
                "Temel 10 + aylık add-on (+{{pack}} alarm)",
                { pack: packSize },
              )
            : t("settings.plan_alerts_free_tier", "İlk 10 alarm ücretsiz")
        }
        used={alertsUsed}
        max={alertsMax}
        footer={
          <>
            <span className={styles.quotaProgressCaption}>
              {t("settings.plan_alerts_remaining_hint", "{{count}} hak kaldı", {
                count: alertsRemaining,
              })}
            </span>
            {canPurchase && limits.can_purchase ? (
              <Button
                type="link"
                size="small"
                className={styles.alertQuotaCta}
                onClick={() => {
                  if (isEnterprise) {
                    if (typeof onContactSales === "function") onContactSales();
                    return;
                  }
                  setShowUpgrade(true);
                }}
              >
                {isEnterprise
                  ? t("sonic_prospect.plans_contact_sales")
                  : t(
                      "settings.plan_org_addon_subscribe",
                      "Aylık add-on (+{{pack}} KPI + alarm)",
                      { pack: packSize },
                    )}
              </Button>
            ) : null}
            {canPurchase && !limits.can_purchase && addonActive ? (
              <span className={styles.alertQuotaManage}>
                {t(
                  "settings.plan_alerts_manage_hint",
                  "İptal için support@pivony.com",
                )}
              </span>
            ) : null}
          </>
        }
      />

      {!isEnterprise ? (
        <AlertLimitUpgradeModal
          open={showUpgrade}
          onClose={() => setShowUpgrade(false)}
          limits={limits}
          returnPath="/settings/plan"
          source="plan"
        />
      ) : null}
    </>
  );
};

export default PlanOrgQuota;
